import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { file_upload_urls, role_urls, rating_urls } from '../Constants/api-constants';
import { Observable, catchError, map, shareReplay, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  private ownRanking$?: Observable<any>;
  private ownRankingToken = '';

  constructor(private readonly httpClient: HttpClient) { }

  fileUpload(formData: any) {
    const reqHeader = new HttpHeaders({
      'enctype': 'multipart/form-data',
      'auth': 'Bearer ' + (globalThis.window?.localStorage ? localStorage.getItem('token') ?? '' : '')
    });
    return this.httpClient.post(file_upload_urls.user_profile_url, formData,
      {
        headers: reqHeader,
        params: {},
        observe: 'response',
      }
    ).pipe(
      map((response: any) => {
        return response;
      }));
  }
  uploadProfilePic(data: any) {
    const reqHeader = new HttpHeaders({
      'enctype': 'multipart/form-data',
      'auth': 'Bearer ' + (globalThis.window?.localStorage ? localStorage.getItem('token') ?? '' : '')
    });
    return this.httpClient.post(file_upload_urls.user_profile_upload, data,
      {
        headers: reqHeader,
        params: {},
        observe: 'response',
      }
    ).pipe(
      map((response: any) => {
        return response;
      }));
  }
  getUserProfilePic(user_id: any) {
    const reqHeader = new HttpHeaders({
      'enctype': 'multipart/form-data',
      'auth': 'Bearer ' + (globalThis.window?.localStorage ? localStorage.getItem('token') ?? '' : '')
    });
    return this.httpClient.get(file_upload_urls.get_user_profile_pic + '?user_id=' + user_id,
      {
        headers: reqHeader,
        params: {},
        observe: 'response',
      }
    ).pipe(
      map((response: any) => {
        return response;
      }));
  }

  getUserRoleDetails(user_id: any) {
    const reqHeader = new HttpHeaders({
      'auth': 'Bearer ' + (globalThis.window?.localStorage ? localStorage.getItem('token') ?? '' : '')
    });
    return this.httpClient.get(role_urls.user_role + '?user_role_id=' + user_id,
      {
        headers: reqHeader,
        params: {},
        observe: 'response',
      }
    ).pipe(
      map((response: any) => {
        return response;
      }));
  }

  /** Own ranking is cached per token; lookups for another user_role_id always hit the API. */
  getratingranking(user_role_id?: any): Observable<any> {
    const token = globalThis.window?.localStorage
      ? localStorage.getItem('token') ?? ''
      : '';
    if (user_role_id) {
      return this.requestRatingRanking(token, user_role_id);
    }
    if (this.ownRanking$ && this.ownRankingToken === token) {
      return this.ownRanking$;
    }
    this.ownRankingToken = token;
    const request$: Observable<any> = this.requestRatingRanking(token).pipe(
      catchError((error) => {
        if (this.ownRanking$ === request$) {
          this.ownRanking$ = undefined;
        }
        return throwError(() => error);
      }),
      shareReplay(1)
    );
    this.ownRanking$ = request$;
    return request$;
  }

  private requestRatingRanking(token: string, user_role_id?: any): Observable<any> {

    const reqHeader = new HttpHeaders({
      'accept': 'application/json',
      'tenant': environment.tenant_Name,
      'Auth': 'Bearer ' + token
    });

    let url = rating_urls.get_current_ranking;
    if (user_role_id) {
      url += '?user_role_id=' + user_role_id;
    }

    return this.httpClient.get(url, {
      headers: reqHeader,
      observe: 'response',
    }).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

}
